export const ACCOUNT_OPTIONS_MODAL_EVENT = 'output:internal:account-options-modal';

export function openAccountOptionsModal() {
  window.dispatchEvent(new CustomEvent(ACCOUNT_OPTIONS_MODAL_EVENT, { detail: {} }));
}
